import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.emailsGridState || initialState;

export const selectEmailTemplates = createSelector(
  [selectDomain],
  emailsGridState => emailsGridState.emailTemplates,
);

export const selectEmailTemplatesLoading = createSelector(
  [selectEmailTemplates],
  emailTemplates => emailTemplates.loading,
);

export const selectLastRefreshTrigger = createSelector(
  [selectDomain],
  emailsGridState => emailsGridState.lastRefreshTrigger ?? 0,
);

export const selectGenerateTemplates = createSelector(
  [selectDomain],
  emailsGridState =>
    emailsGridState.generateTemplates ?? {
      loading: false,
      error: null,
    },
);

export const selectGenerateTemplatesLoading = createSelector(
  [selectGenerateTemplates],
  generateTemplates => generateTemplates.loading,
);

export const selectGenerateInProgress = createSelector(
  [selectDomain],
  emailsGridState => emailsGridState.generateInProgress ?? false,
);

export const selectGenerateStartedDealerId = createSelector(
  [selectDomain],
  emailsGridState => emailsGridState.generateStartedDealerId ?? null,
);

export const selectGenerateProgress = createSelector(
  [selectDomain],
  emailsGridState => emailsGridState.generateProgress ?? { current: 0, total: 1 },
);
